import React, { useEffect, useState } from 'react'
import { useGetFormDropDownsUserApiQuery, useSubmitHomeFormMutation } from '../../../../core/Features/api/homeForm/homeForm';
import toast, { Toaster } from 'react-hot-toast';
import ImageWithBasePath from '../../../../core/common/imageWithBasePath';
import CustomSelect from './CustomSelect'
interface FormData {
  firstName: string;
  lastName: string;
  email: string;
  mobileCodenumber: string;
  mobile: string;
  studyDestination: string;
  likeToStart: string;
  nearIdpOffice: string;
  modeOfCounselling: string;
  studyLevel: string;
  fundYourStudy: string;
  agreeTerms: boolean;
  contactPermission: boolean;
  receiveOffers: boolean;
}

const initialFormData: FormData = {
  firstName: '',
  lastName: '',
  email: '',
  mobileCodenumber: '+91',
  mobile: '',
  studyDestination: '',
  likeToStart: '',
  nearIdpOffice: '',
  modeOfCounselling: '',
  studyLevel: '',
  fundYourStudy: '',
  agreeTerms: false,
  contactPermission: false,
  receiveOffers: false,
};

const Unlock = () => {

  const { data, isLoading, isError } = useGetFormDropDownsUserApiQuery({});
  const [submitForm] = useSubmitHomeFormMutation();

  const [formData, setFormData] = useState<FormData>(initialFormData)

  const apiValues = Array.isArray(data?.data) ? data.data : [];

  const [errors, setErrors] = useState<Partial<Record<keyof FormData, string>>>({});

  const handleChange = (field: keyof FormData, value: string | boolean) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    // Clear error when user starts typing/selecting
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const validateForm = () => {
    const newErrors: Partial<Record<keyof FormData, string>> = {};

    // Fixed validation logic - removed redundant condition
    if (!formData.firstName.trim()) newErrors.firstName = 'First name is required.';
    if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required.';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = 'Invalid email address.';
    }
    if (!formData.mobile.trim()) newErrors.mobile = 'Mobile number is required.';
    if (!formData.studyDestination) newErrors.studyDestination = 'Study destination is required.';
    if (!formData.likeToStart) newErrors.likeToStart = 'When to start is required.';
    if (!formData.nearIdpOffice) newErrors.nearIdpOffice = 'Near IDP Office is required.';
    if (!formData.modeOfCounselling) newErrors.modeOfCounselling = 'Mode of counselling is required.';
    if (!formData.studyLevel) newErrors.studyLevel = 'Study level is required.';
    if (!formData.fundYourStudy) newErrors.fundYourStudy = 'Funding method is required.';
    if (!formData.agreeTerms) newErrors.agreeTerms = 'You must agree to the Terms and Privacy Policy.';
    if (!formData.contactPermission) newErrors.contactPermission = 'Please allow contact to proceed.';
    if (!formData.receiveOffers) newErrors.receiveOffers = 'Please opt-in to receive updates and offers.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await submitForm(formData).unwrap();
      toast.success("Form submitted successfully!");
      setFormData(initialFormData);
      setErrors({});
    } catch (error: any) {
      toast.error(error?.message)
    }
  };

  const getOptionsByGroupId = (groupId: string) => {
    return apiValues.find((group: any) => group._id === groupId)?.items || [];
  };

  return (
    <div className="unlock-root">

      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          className: '',
          duration: 3000,
          style: {
            background: '#fff',
            color: '#363636',
            padding: '16px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '500',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#4ade80',
              secondary: '#fff',
            },
            style: {
              border: '1px solid #4ade80',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
            style: {
              border: '1px solid #ef4444',
            },
          },
        }}
      />

      <style>{`
        .unlock-root {
          background: #fafafa;
          min-height: 100vh;
          padding: 40px 0;
        }
        .unlock-container {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          gap: 40px;
          align-items: center;
          border-radius: 12px;
        }
        .unlock-left {
          flex: 1;
          padding: 40px 0 40px 40px;
        }
        .unlock-badge {
          background: #ffe9f0;
          color: #ff4081;
          display: inline-block;
          padding: 4px 16px;
          border-radius: 20px;
          font-weight: 500;
          font-size: 14px;
          margin-bottom: 16px;
        }
        .unlock-title {
          font-size: 36px;
          font-weight: 700;
          color: #23235f;
          margin: 16px 0 8px;
        }
        .unlock-title .highlight {
          color: #ff0000;
        }
        .unlock-desc {
          color: #888;
          font-size: 16px;
          margin-bottom: 32px;
        }
        .unlock-img {
          max-width: 340px;
          border-radius: 16px;
          margin-top: 24px;
          width: 100%;
          height: auto;
        }
        .unlock-form-section {
          flex: 1.2;
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 2px 16px rgba(0,0,0,0.06);
          padding: 40px;
        }
        .unlock-form-title {
          color: #23235f;
          font-weight: 700;
          font-size: 22px;
          margin-bottom: 24px;
        }
        .unlock-form {
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
        }
        .unlock-form input,
        .unlock-form select {
          width: 100%;
          padding: 10px 12px;
          border-radius: 8px;
          border: 1px solid #e0e0e0;
          font-size: 16px;
          margin-top: 4px;
          margin-bottom: 8px;
          background: #fafbfc;
        }
        .unlock-form label {
          font-size: 15px;
          font-weight: 500;
        }
        .unlock-form .checkbox-label {
          display: flex;
          align-items: center;
          font-size: 14px;
        }
        .unlock-form .checkbox-label input[type="checkbox"] {
          margin-right: 8px;
        }
        .unlock-form .unlock-submit-btn {
          background: #ff0000;
          color: #fff;
          border: none;
          border-radius: 24px;
          padding: 14px 0;
          width: 100%;
          font-weight: 600;
          font-size: 18px;
          cursor: pointer;
          margin-top: 16px;
        }
        .error-message {
          color: red;
          font-size: 12px;
          margin-top: 4px;
        }
        @media (max-width: 900px) {
          .unlock-container {
            flex-direction: column;
            gap: 0;
          }
          .unlock-left {
            padding: 32px 24px 0 24px;
            text-align: center;
          }
          .unlock-form-section {
            padding: 32px 16px;
            width: 100%;
            box-sizing: border-box;
          }
        }
        @media (max-width: 600px) {
          .unlock-root {
            padding: 16px 0;
          }
          .unlock-title {
            font-size: 24px;
          }
          .unlock-form-title {
            font-size: 18px;
          }
          .unlock-img {
            max-width: 220px;
            margin-top: 16px;
          }
        }
      `}</style>
      <div className="unlock-container">
        {/* Left Section */}
        <div className="unlock-left">
          <div className="unlock-badge !text-[#ff0000]">Get FREE Counselling Today!</div>
          <h1 className="unlock-title">
            Unlock Your Global Future<br />
            with <span className="highlight">Palanivel Overseas</span>
          </h1>
          <p className="unlock-desc" data-aos="flip-left">
            Enter your details and our expert will reach out to you to discuss your plans. By the way, all our services are free!
          </p>
          <img className=" hidden md:block" src="https://palanivelstorage.s3.ap-south-1.amazonaws.com/mediaBucketname/267e2ccc702cae26b0fef81336ca3450.png" alt="Woman pointing" />
        </div>
        {/* Right Section (Form) */}
        <div className="unlock-form-section">
          <h2 className="unlock-form-title">
            Get Expert Guidance – Book Your FREE Consultation Today!
          </h2>

          <form className="unlock-form" onSubmit={handleSubmit} noValidate >
            <div style={{ flex: '1 1 45%' }}>
              <label>First Name <span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                placeholder=""
                value={formData.firstName}
                onChange={(e) => handleChange("firstName", e.target.value)}
                required
              />
              {errors.firstName && (
                <div className="error-message">{errors.firstName}</div>
              )}
            </div>

            <div style={{ flex: '1 1 45%' }}>
              <label>Last Name <span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                placeholder=""
                value={formData.lastName}
                onChange={(e) => handleChange("lastName", e.target.value)}
                required
              />
              {errors.lastName && <div className="error-message">{errors.lastName}</div>}
            </div>

            <div style={{ flex: '1 1 100%' }}>
              <label>Email address <span style={{ color: 'red' }}>*</span></label>
              <input
                type="email"
                placeholder=""
                value={formData.email}
                onChange={(e) => handleChange("email", e.target.value)}
                required
              />
              {errors.email && <div className="error-message">{errors.email}</div>}
            </div>

            <div style={{ flex: '1 1 100%' }}>
              <label>Mobile number <span style={{ color: 'red' }}>*</span></label>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ background: '#f3f3f3', padding: '0 12px', borderRadius: 6, border: '1px solid #eee', height: 40, display: 'flex', alignItems: 'center' }}>
                  +91
                  <img src="https://flagcdn.com/in.svg" alt="IN" style={{ width: 20, marginLeft: 4 }} />
                </span>
                <input
                  type="tel"
                  style={{ flex: 1 }}
                  placeholder=""
                  value={formData.mobile}
                  onChange={(e) => handleChange("mobile", e.target.value)}
                  required
                />
              </div>
              {errors.mobile && <div className="error-message">{errors.mobile}</div>}
            </div>



            <div style={{ flex: '1 1 45%' }}>
              <label>Preferred Study destination<span style={{ color: 'red' }}>*</span></label>
              <CustomSelect
                data={data?.destinations}
                value={formData.studyDestination}
                onChange={(val) => handleChange("studyDestination", val)}
                labelKey="countryName"
                valueKey="_id"
                imageKey="countryImage"
                placeholder="Select a country"
              />

              {/* <select
                value={formData.studyDestination}
                onChange={(e) => handleChange("studyDestination", e.target.value)}
                required
              >
                <option value="">Select</option>
                {data?.destinations?.map((item: any) => (
                  <option key={item._id} value={item._id}>
                    {console.log("countryImage", item?.countryImage)}ssss
                    <ImageWithBasePath source={item?.countryImage} className="rounded-full"
                      height={40}
                      width={40}
                      alt="Img" />
                    {item?.countryName}</option>
                ))}
              </select> */}
              {errors.studyDestination && <div className="error-message">{errors.studyDestination}</div>}
            </div>

            <div style={{ flex: '1 1 45%' }}>
              <label>When would you like to start? <span style={{ color: 'red' }}>*</span></label>
              {/* <select
                value={formData.likeToStart}
                onChange={(e) => handleChange("likeToStart", e.target.value)}
                required
              >
                <option value="">Select</option>
                {getOptionsByGroupId("0")?.map((item: any) => (
                  <option key={item._id} value={item._id}>{item.name}</option>
                ))}
              </select> */}
              <CustomSelect
                data={getOptionsByGroupId("0")}
                value={formData.likeToStart}
                onChange={(val) => handleChange("likeToStart", val)}
                labelKey="name"
                valueKey="_id"
                placeholder="Select"
              />
              {errors.likeToStart && <div className="error-message">{errors.likeToStart}</div>}
            </div>

            <div style={{ flex: '1 1 45%' }}>
              <label>Nearest Palanivel Office <span style={{ color: 'red' }}>*</span></label>
              <CustomSelect
                data={getOptionsByGroupId("1")}
                value={formData.nearIdpOffice}
                onChange={(val) => handleChange("nearIdpOffice", val)}
                labelKey="name"
                valueKey="_id"
                placeholder="Select"
              />
              {/* <select
                value={formData.nearIdpOffice}
                onChange={(e) => handleChange("nearIdpOffice", e.target.value)}
                required
              >
                <option value="">Select</option>
                {getOptionsByGroupId("1")?.map((item: any) => (
                  <option key={item._id} value={item._id}>{item.name}</option>
                ))}
              </select> */}
              {errors.nearIdpOffice && <div className="error-message">{errors.nearIdpOffice}</div>}
            </div>

            <div style={{ flex: '1 1 45%' }}>
              <label>Preferred mode of counselling <span style={{ color: 'red' }}>*</span></label>
              <CustomSelect
                data={getOptionsByGroupId("2")}
                value={formData.modeOfCounselling}
                onChange={(val) => handleChange("modeOfCounselling", val)}
                labelKey="name"
                valueKey="_id"
                placeholder="Select"
              />
              {/* <select
                value={formData.modeOfCounselling}
                onChange={(e) => handleChange("modeOfCounselling", e.target.value)}
                required
              >
                <option value="">Select</option>
                {getOptionsByGroupId("2")?.map((item: any) => (
                  <option key={item._id} value={item._id}>{item.name}</option>
                ))}
              </select> */}
              {errors.modeOfCounselling && <div className="error-message">{errors.modeOfCounselling}</div>}
            </div>

            <div style={{ flex: '1 1 45%' }}>
              <label>Preferred study level <span style={{ color: 'red' }}>*</span></label>
              <CustomSelect
                data={data?.studyLevel}
                value={formData.studyLevel}
                onChange={(val) => handleChange("studyLevel", val)}
                labelKey="levelName"
                valueKey="_id"
                placeholder="Select"
              />

              {/* <select
                value={formData.studyLevel}
                onChange={(e) => handleChange("studyLevel", e.target.value)}
                required
              >
                <option value="">Select</option>
                {data?.studyLevel?.map((item: any) => (
                  <option key={item._id} value={item._id}>{item.levelName}</option>
                ))}
              </select> */}
              {errors.studyLevel && <div className="error-message">{errors.studyLevel}</div>}
            </div>

            <div style={{ flex: '1 1 45%' }}>
              <label>How will you fund your studies? <span style={{ color: 'red' }}>*</span></label>

              <CustomSelect
                data={getOptionsByGroupId("3")}
                value={formData.fundYourStudy}
                onChange={(val) => handleChange("fundYourStudy", val)}
                labelKey="name"
                valueKey="_id"
                placeholder="Select"
              />
              {/* <select
                value={formData.fundYourStudy}
                onChange={(e) => handleChange("fundYourStudy", e.target.value)}
                required
              >
                <option value="">Select</option>
                {getOptionsByGroupId("3")?.map((item: any) => (
                  <option key={item._id} value={item._id}>{item.name}</option>
                ))}
              </select> */}
              {errors.fundYourStudy && <div className="error-message">{errors.fundYourStudy}</div>}
            </div>

            <div style={{ flex: '1 1 100%', marginTop: 8 }}>
              <div className="unlock-radio-group" style={{ display: 'flex', flexWrap: 'wrap', gap: 12, flexDirection: 'column' }}>

                <label className="flex items-start gap-x-2 text-sm leading-relaxed break-words">
                  <span>
                    <input
                      type="checkbox"
                      className="mt-0.5 scale-125"
                      checked={formData.contactPermission}
                      onChange={(e) => handleChange("contactPermission", e.target.checked)}
                    />
                  </span>
                  <span>
                    Please contact me by phone, email or SMS to assist my enquiry
                  </span>
                </label>
                {errors.contactPermission && <div className="error-message" style={{ marginLeft: 28 }}>{errors.contactPermission}</div>}

                <label className="flex items-start gap-x-2 text-sm leading-relaxed break-words">
                  <span>
                    <input
                      type="checkbox"
                      className="mt-0.5 scale-125"
                      checked={formData.receiveOffers}
                      onChange={(e) => handleChange("receiveOffers", e.target.checked)}
                    />
                  </span>
                  <span>
                    I would like to receive updated and offer from Palanivel Overseas
                  </span>
                </label>
                {errors.receiveOffers && <div className="error-message" style={{ marginLeft: 28 }}>{errors.receiveOffers}</div>}

                <label className="flex items-start gap-x-2 text-sm leading-relaxed break-words">
                  <span>
                    <input
                      type="checkbox"
                      className="mt-0.5 scale-125"
                      checked={formData.agreeTerms}
                      onChange={(e) => handleChange("agreeTerms", e.target.checked)}
                    />
                  </span>
                  <span>
                    I agree to Palanivel Overseas{' '}
                    <a href="#" className="text-[#ff0000] underline mx-1">Terms</a>
                    {' '}and{' '}
                    <a href="#" className="text-[#ff0000] underline mx-1">Privacy policy</a>
                  </span>
                </label>
                {errors.agreeTerms && <div className="error-message" style={{ marginLeft: 28 }}>{errors.agreeTerms}</div>}

              </div>

              <style>{`
                @media (max-width: 700px) {
                  .unlock-radio-group {
                    flex-direction: column !important;
                    gap: 8px !important;
                  }
                }
                .checkbox-label {
                  display: flex;
                  align-items: flex-start;
                  font-size: 14px;
                }
                .checkbox-label input[type="radio"] {
                  margin-top: 2px;
                }
              `}</style>
            </div>

            <div style={{ flex: '1 1 100%' }}>
              <button type="submit" className="unlock-submit-btn">
                Start your journey now
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Unlock